import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavItem } from '../../types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, MatRippleModule],
  selector: 'wcg-nav-tabs',
  styleUrl: './nav-tabs.component.scss',
  template: `
    <nav class="mat-tab-nav">
      @for (item of navItems().values(); track item.path) {
        @if (item.path) {
          <a
            [routerLink]="item.path"
            routerLinkActive="mat-tab-active"
            #rla="routerLinkActive"
            class="mat-tab-link"
            matRipple
          >
            {{ item.label }}
            @if (item.badge) {
              <span class="tab-badge">{{ item.badge }}</span>
            }
            @if (rla.isActive) {
              <span class="mat-tab-indicator"></span>
            }
            <!-- Badge for success or attention -->
            @if (item.alert) {
              <span [class]="item.alertClass || 'indication-badge'"></span>
            }
          </a>
        }
      }
    </nav>
  `,
})
export class NavTabsComponent {
  navItems = input<Set<NavItem>>(new Set<NavItem>([]));
}
